import React from 'react'
import {
  FileText, FileCode, FileImage, Archive, File,
  FileVideo, FileAudio, Database, Globe, Settings
} from 'lucide-react'
import { SiPhp, SiJavascript, SiTypescript, SiCss, SiHtml5, SiPython, SiMarkdown } from 'react-icons/si'

const extMap = {
  // Code
  php:    { icon: <SiPhp />,        color: 'text-purple-400' },
  js:     { icon: <SiJavascript />, color: 'text-yellow-400' },
  mjs:    { icon: <SiJavascript />, color: 'text-yellow-400' },
  jsx:    { icon: <SiJavascript />, color: 'text-cyan-400'   },
  ts:     { icon: <SiTypescript />, color: 'text-blue-400'   },
  tsx:    { icon: <SiTypescript />, color: 'text-blue-400'   },
  css:    { icon: <SiCss />,       color: 'text-blue-500'   },
  scss:   { icon: <SiCss />,       color: 'text-pink-400'   },
  html:   { icon: <SiHtml5 />,      color: 'text-orange-400' },
  htm:    { icon: <SiHtml5 />,      color: 'text-orange-400' },
  py:     { icon: <SiPython />,     color: 'text-yellow-300' },
  md:     { icon: <SiMarkdown />,   color: 'text-gray-500'   },
  // Config / text
  json:     { icon: <FileCode size={15} />,  color: 'text-amber-400'  },
  xml:      { icon: <FileCode size={15} />,  color: 'text-orange-300' },
  yaml:     { icon: <FileCode size={15} />,  color: 'text-red-400'    },
  yml:      { icon: <FileCode size={15} />,  color: 'text-red-400'    },
  toml:     { icon: <FileCode size={15} />,  color: 'text-orange-400' },
  env:      { icon: <Settings size={15} />,  color: 'text-emerald-400' },
  htaccess: { icon: <Settings size={15} />,  color: 'text-emerald-400' },
  sh:       { icon: <FileCode size={15} />,  color: 'text-green-400'  },
  bash:     { icon: <FileCode size={15} />,  color: 'text-green-400'  },
  sql:      { icon: <Database size={15} />,  color: 'text-sky-400'    },
  txt:      { icon: <FileText size={15} />,  color: 'text-gray-400'   },
  log:      { icon: <FileText size={15} />,  color: 'text-gray-400'   },
  // Images
  jpg:  { icon: <FileImage size={15} />, color: 'text-purple-300' },
  jpeg: { icon: <FileImage size={15} />, color: 'text-purple-300' },
  png:  { icon: <FileImage size={15} />, color: 'text-purple-300' },
  gif:  { icon: <FileImage size={15} />, color: 'text-purple-300' },
  webp: { icon: <FileImage size={15} />, color: 'text-purple-300' },
  svg:  { icon: <Globe size={15} />,     color: 'text-pink-300'   },
  ico:  { icon: <FileImage size={15} />, color: 'text-purple-300' },
  // Archives
  zip:  { icon: <Archive size={15} />, color: 'text-yellow-500' },
  tar:  { icon: <Archive size={15} />, color: 'text-yellow-500' },
  gz:   { icon: <Archive size={15} />, color: 'text-yellow-500' },
  bz2:  { icon: <Archive size={15} />, color: 'text-yellow-500' },
  rar:  { icon: <Archive size={15} />, color: 'text-yellow-500' },
  // Video / Audio
  mp4:  { icon: <FileVideo size={15} />, color: 'text-rose-400' },
  avi:  { icon: <FileVideo size={15} />, color: 'text-rose-400' },
  mov:  { icon: <FileVideo size={15} />, color: 'text-rose-400' },
  mp3:  { icon: <FileAudio size={15} />, color: 'text-green-300' },
  wav:  { icon: <FileAudio size={15} />, color: 'text-green-300' },
}

export function getFileIcon(name, size = 15) {
  const ext = name.split('.').pop()?.toLowerCase() ?? ''
  const match = extMap[ext]
  if (match) return { icon: React.cloneElement(match.icon, { size }), color: match.color }
  return { icon: <File size={size} />, color: 'text-gray-400' }
}
